// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__kBeLa","point":"Menu_point__vy5kV","btn":"Menu_btn__zLGb6","totalCount":"Menu_totalCount__3klHx","wrapper":"Menu_wrapper__noIpg"};